<script>
  import store from '~/Library/store'
  import {onMount} from 'svelte'
  import {navigate} from 'svelte-routing'
  import Layout from '~/Components/Layout/Layout'
  import LoginMolecule from '~/Components/Molecules/Login'
  import RecoverMolecule from '~/Components/Molecules/Recover'
  import ResetMolecule from '~/Components/Molecules/Reset'
  import {Link} from 'svelte-routing'
  import {loginUser, createPasswordReset} from '~/Library/api'

  let isFormInvalid = false
  let isSubmitting = false
  let form = null
  let user = {}

  export let option = 'login'
  const options = {
    login: {
      title: 'Sign In', 
      content: null,
      action: {
        title: 'Forgotten your password?', 
        path: '/recover-account'
      },
      cta: 'Sign In',
      validation: 'Login information not recognised. Please try again.',
      component: LoginMolecule,
      contact: true
    },
    recover: {
      title: 'Forgot password?', 
      content: 'Please enter the email address associated with this account and we will send you a new password.',
      validation: 'Please enter a valid email.',
      action: null,
      cta: 'Send email',
      component: RecoverMolecule,
    },
    success: {
      title: 'Sent Email',
      action: null, 
      cta: null, 
      component: null, 
    }
  }

  onMount(() => {
    window.scrollTo(0, 0)
  })

  async function submit(e){
    e.preventDefault()

    if(!isSubmitting){

      isSubmitting = true 
      isFormInvalid = false

      switch(option){

        case 'login':
          await loginUser(user).then((rsp) => {
            store.setAttribute('user', rsp.data.authenticate.item)
            const redirect = window.location.pathname
            navigate(redirect === '/login' ? '/' : redirect)
          }).catch((e) => {
            isFormInvalid = true 
          })
          break

        case 'recover':
          if (validateEmail(user.identity)){
            await createPasswordReset({
              email: user.identity
            }).then((rsp) => {
              options.success.content = `<p>We have sent an email to:</p><span class="auth__success-email">${user.identity}</span><p>Please click the link in the email to reset your password.`
              option = 'success'
            }).catch((err) => {
              isFormInvalid = true 
            })

          } else {
            isFormInvalid = true 
          }
          break

      }

      isSubmitting = false 

    }

  }

  function updateUser(ev) {
    user = ev.detail
  }

  function validateEmail(attribute){
    return attribute.match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    )
  }

</script>

<Layout>

  <div class="auth">

    <img class="auth__background" src="/static/shapes/rectangle.svg" alt="">

    <img src="static/illustrations/laptop.svg" alt="">

    <div class="auth__right">

      <h1 class="heading">{options[option].title}</h1>

      {#if options[option].content}

        <p>{@html options[option].content}</p>

      {/if}

      {#if options[option].component}

        <form bind:this={form} on:submit={submit}>

          <svelte:component this={options[option].component} on:formEdited={updateUser} />

          {#if isFormInvalid}

            <div class="auth__validation">
            
              <img src="static/icons/error.svg" alt="">
              
              <span class="auth__message">{options[option].validation}</span>
              
            </div>

          {/if}

          {#if options[option].action}

            <Link to={options[option].action.path}>

              <span class="auth__action">

                <u>{options[option].action.title}</u>

              </span>

            </Link>

          {/if}

          <button class="auth__cta">{options[option].cta}</button>

        </form>

      {/if}

      {#if options[option].contact}

        <a href="mailto:{process.env.CONTACT_EMAIL}">
          
          <span class="auth__action">

            Don't have an account?

            <span class="accent">

              <u>Get in touch</u>

            </span>

          </span>
        
        </a>

      {/if}

    </div>

  </div>

</Layout>

<style lang="scss">

  :global(.auth__success-email){
    display: inline-block;
    font-size: 1.25rem;
    color: var(--heading-colour);
    margin-top: 1rem;
    margin-bottom: 3rem;
  }

  .auth {

    $this: &; 

    display: flex;
    align-items: flex-start;
    position: relative;
    margin: 4rem;

    h1.heading {
      font-size: 3.125rem;  
      margin-bottom: 3rem;
      + p {
        margin-bottom: 3rem;
        font-size: 0.875rem;
      }
    }

    &__background {

      position: absolute;
      height: 55rem;
      width: 55rem;
      top: -800px;
      transform: rotate(60deg);
      left: 500px;
      z-index: -10;

    }   
    
    @media only screen and (max-width: 768px) {

      img {
        width: 15rem;
        height: 15rem;
      }

    }

    &__right {

      margin-left: 6rem;
      flex-grow: 1;

      form {
        display: flex;
        flex-direction: column;
      }

      #{$this}__label {
        font-size: 0.875rem;
        color: var(--heading-colour); 
        margin-bottom: 0.5rem;
      }

      #{$this}__action {
        display: block;
        font-size: 0.875rem;
      }

      #{$this}__cta {
        border-radius: 2rem;
        background-color: var(--accent-colour);
        color: white;
        padding: 1.125rem 3rem;
        font-weight: bold;
        font-size: 1.125rem;
        outline: none;
        border: none;
        margin-top: 3rem;
        margin-bottom: 2rem;
        width: fit-content;
        cursor: pointer;
      }

      #{$this}__validation {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        span {
          color: var(--invalid-colour);
          font-size: 0.875rem;
          font-weight: 300;
          margin-left: 0.5rem;
        }
      }
    }

    @media only screen and (max-width: 576px) {
      flex-direction: column; 
      margin: 0px;
      img {
        display: none;
      }
      &__right {
        width: 100%;
        margin: 2rem 0rem 0rem 0rem;
      }
    }
  }

</style>